export const AllowedConnectorTypes = [
  'amazonRDSReader',
  's3Reader',
  's3Writer',
  'amazonSESConnector',
  'awsElasticsearchReader5x',
  'amazonRedshiftReader',
  'amazonRedshiftWriter',
  'salesforceReader',
  'salesforceV2Reader',
  'salesforceWriter',
  'salesforceBulkWriter',
  'salesforceBulkReader',
  'httpReader',
  'httpWriter',
  'httpV2Reader',
  'sqlServer',
  'localFileReader',
  'localFileWriter',
  'localFileImporter',
  'amazonRDSWriter',
  'infosilemReader',
  'ethosReader',
  'ethosWriter',
  'ethosV2AsyncReader',
  'ethosV2Reader',
  'zoomReader',
  'zoomWriter',
  'zoomGraphQLReader',
  'json',
  'graphqlReader',
  'sftpReader',
  'sftpWriter',
  'lingkWriter',
  'lingkAdapterReader',
  'lingkAdapterWriter',
  'anthologyReader',
  'anthologyWriter',
  'brightSpaceValenceApiReader',
  'brightSpaceValenceApiWriter',
  'jdbcReader',
  'blackboardReader',
  'blackboardWriter',
  'canvasReader',
  'canvasWriter',
  'canvasGraphQLReader',
  'colleagueReader',
  'colleagueWriter',
  'microsoftCosmosDbReader',
  'microsoftCosmosDbV2Reader',
  'docuSignReader',
  'edfiReader',
  'edfiWriter',
  'edReadyReader',
  'element451Reader',
  'element451Writer',
  'googleSpreadsheetReader',
  'googleSpreadsheetWriter',
  'googleBigQueryReader',
  'googleBigQueryWriter',
  'leadSquaredReader',
  'leadSquaredWriter',
  'learningStreamReader',
  'learningStreamWriter',
  'logReader',
  'moodleReader',
  'moodleWriter',
  'peoplesoftReader',
  'peoplesoftWriter',
  'paycomReader',
  'paycomWriter',
  'oDataReader',
  'httpXmlConnector',
  'ethosGraphQLReader',
  'jdbcWriter',
];

export const AllowedReaderConnectorTypes = [
  'amazonRDSReader',
  's3Reader',
  'awsElasticsearchReader5x',
  'amazonRedshiftReader',
  'salesforceReader',
  'salesforceV2Reader',
  'salesforceBulkReader',
  'httpReader',
  'httpV2Reader',
  'localFileReader',
  'infosilemReader',
  'ethosReader',
  'ethosV2AsyncReader',
  'ethosV2Reader',
  'zoomReader',
  'zoomGraphQLReader',
  'graphqlReader',
  'sftpReader',
  'lingkAdapterReader',
  'anthologyReader',
  'brightSpaceValenceApiReader',
  'jdbcReader',
  'blackboardReader',
  'canvasReader',
  'canvasGraphQLReader',
  'colleagueReader',
  'microsoftCosmosDbReader',
  'microsoftCosmosDbV2Reader',
  'docuSignReader',
  'edfiReader',
  'edReadyReader',
  'element451Reader',
  'googleSpreadsheetReader',
  'googleBigQueryReader',
  'leadSquaredReader',
  'learningStreamReader',
  'logReader',
  'moodleReader',
  'peoplesoftReader',
  'paycomReader',
  'oDataReader',
  'ethosGraphQLReader',
];
